import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, headerMenusActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, headerMenusActions);

export default slice.reducer;
